import { CardGroup as FuseCardGroup } from "@tvg/fuse/card-group";
import { GridContainer, GridItem, GridRow } from "@tvg/fuse/grid";
import { SpacingWrapper } from "@tvg/fuse/spacing-wrapper";

import React from "react";
import { AmpCardGroup } from "types/amplience";
import Card from "./Card";
import { cardGroupLayoutConfig } from "./config";

export interface CardGroupProps {
  config: AmpCardGroup;
}

export const CardGroup: React.FC<CardGroupProps> = ({
  config: { heading: title, cards, cardsImageRatio, cardGroupLayout },
}) => {
  const layout = cardGroupLayoutConfig[cardGroupLayout];
  return (
    <SpacingWrapper marginBottom="l">
      <GridContainer>
        <GridRow>
          <GridItem xxs={12} l={10} colStart-l={2}>
            <FuseCardGroup
              title={title}
              titleTag="h2"
              xxsColumns={layout?.xxsColumns as 1 | 2}
              mColumns={layout?.mColumns as 2 | 3 | 4}
              lColumns={layout?.lColumns as 2 | 3 | 4}
              dataTestId="content-card-group"
            >
              {cards.map((config) => (
                <Card
                  key={config._meta.deliveryId}
                  config={config}
                  imageRatio={cardsImageRatio}
                  headerTag={title ? "h3" : "h2"}
                />
              ))}
            </FuseCardGroup>
          </GridItem>
        </GridRow>
      </GridContainer>
    </SpacingWrapper>
  );
};
